export function randomString(): string {
    return Math.random().toString(32).replace('0.', '') + Math.random().toString(32).replace('0.', '');
}
